import { Component, Input, OnInit } from '@angular/core';
import { Canal } from '../../_models/canal';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { Rol } from '../../_models/rol';
import { CanalRol } from '../../_models/canal-rol';
import { RolesService } from '../../_services/roles.service';
import { CanalRolService } from '../../_services/canal-rol.service';

@Component( {
  selector: 'app-canales-roles',
  templateUrl: 'canales-roles.component.html'
} )

export class CanalesRolesComponent implements OnInit {

  @Input() canal: Canal;
  lisRoles: SelectItem[] = [];
  lisRolesTodos: Rol[] = [];
  carInformacionInicial = true;
  lisCanalesRoles: CanalRol[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  canRol: CanalRol;
  columnas: any[];

  constructor( private rolServicio: RolesService,
               private conServicio: ConfirmationService,
               private canRolServicio: CanalRolService,
               private nav: NavService,
               private fb: FormBuilder ) {

  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'codigoRol', header: this.nav.buscarMensaje( 'CANALESROLES.LBL_CODIGOROL' ), sort: true },
      { field: 'rol', header: this.nav.buscarMensaje( 'CANALESROLES.LBL_ROL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];


    forkJoin(
      this.canRolServicio.obtenerPorIdCanal( this.canal.idCanal ),
      this.rolServicio.listRoles()
    ).subscribe( ( [ rolCanales, roles ] ) => {
      this.lisCanalesRoles = rolCanales;
      roles.map( ( rol: Rol ) => {
        if ( rol.indicadorHabilitado ) {
          this.lisRolesTodos.push( rol );
          if ( !this.lisCanalesRoles.find( x => x.idRol === rol.idRol ) ) {
            this.lisRoles.push( { label: rol.nombre, value: rol.idRol } );
          }
        }
      } );
      if ( this.lisRolesTodos.length === 0 ) {
        this.nav.setMesage( 4, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'CANALES.MSG_NOEXISTEROLES' )
        } );
      }
      this.carInformacionInicial = false;

    } );
    this.inicializarFormulario();

  }

  inicializarFormulario() {
    this.formulario = this.fb.group( {
      idCanalRol: [ null ],
      idRol: [ null, [ Validators.required ] ],
      idCanal: [ this.canal.idCanal, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.canRol = this.formulario.value;
      this.canRolServicio.crear( this.canRol ).subscribe( rol => {
        this.canRol.idCanalRol = rol.idCanalRol;
        const r = this.lisRolesTodos.find( x => x.idRol === this.canRol.idRol );
        if ( r ) {
          this.canRol.rol = r.nombre;
          this.canRol.codigoRol = r.codigo;
        }

        this.lisCanalesRoles.push( this.canRol );
        const indice = this.lisRoles.findIndex( x => x.value === this.canRol.idRol );
        if ( indice >= 0 ) {
          this.lisRoles.splice( indice, 1 );
        }
        this.submitted = false;
        this.inicializarFormulario();
        this.guardando = false;
        this.nav.setMesage( 1 );
      }, error => {
        this.guardando = false;
        this.nav.setMesage( 3 );
      } );
    }
  }

  cambiarHabilitado( canRol: CanalRol ) {
    if ( !canRol.indicadorHabilitado ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'roles',
        accept: () => {
          this.carInformacionInicial = true;
          this.canRolServicio.actualizar( canRol ).subscribe( rol => {
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
          canRol.indicadorHabilitado = !canRol.indicadorHabilitado;
        }
      } );
    } else {
      this.carInformacionInicial = true;
      this.canRolServicio.actualizar( canRol ).subscribe( producto => {
        this.carInformacionInicial = false;
      } );
    }
  }

  get f() {
    return this.formulario.controls;
  }

}
